import { render, staticRenderFns } from "./importItemsComponent.vue?vue&type=template&id=45c5789e&"
import script from "./importItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./importItemsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports